import React, { Component } from 'react';
import {connect} from "react-redux";
import Websocket from 'react-websocket';
import { TabContent, TabPane, Nav, NavItem, NavLink, Input } from 'reactstrap';
/*import classnames from 'classnames';*/
import Presenter from '../../../chat/ChatSidebar/presenter.js';
import RequestProperties from '../../../chat/ChatSidebar/helper/request.props.js';
import ChatBox from '../../../chat/ChatBox/helper/component/ChatBox.js';
import UserChatList from '../../../chat/ChatSidebar/helper/component/child/UserChatList.js';
import ServerProperties from '../../../config/server.js';
import Notify from '../../../config/notify.js';
import Module from '../../../utils/Render.js';
import Logo from '../../assets/global/img/AssetVault_logo.jpg';
import windowStop from '../../../utils/windowStop.js';
let hidden, visibilityChange, hasFocus;

class Aside extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab           : '1',
            chatElement         : null,
            chatMessage         : null,
            onLineUserElement   : null,
            offLineUserElement  : null,
            botUserElement      : null
        };
        this._isMounted = false
        this.color                  = ['secondary', 'success'];
        this.element                = [];
        this.userChatElement        = [];
        this.userData               = null;
        this.chatBoxRight           = 0;
        this.chatBoxWidth           = 250;
        this.chatBoxMaxWidth        = window.innerWidth - this.chatBoxWidth;
        this.user                   = this.props.UserReducer.username;

        this.handleUserClick                = this.handleUserClick.bind(this);
        this.handleMessage                  = this.handleMessage.bind(this);
        this.sortUserList                   = this.sortUserList.bind(this);
        this.regenerateListChatBox          = this.regenerateListChatBox.bind(this);
        this.onWindowSizeChanged            = this.onWindowSizeChanged.bind(this);
        this.onReadUserSuccess              = this.onReadUserSuccess.bind(this);
        this.onReadBotSuccess               = this.onReadBotSuccess.bind(this);
        this.onReadUserChatSummarySuccess   = this.onReadUserChatSummarySuccess.bind(this);
        this.onReadFailed                   = this.onReadFailed.bind(this);
        this.onReadChatSuccess              = this.onReadChatSuccess.bind(this);
        this.onReadChatFailed               = this.onReadChatFailed.bind(this);
        this.messageSentHandler             = this.messageSentHandler.bind(this);
        this.closeChatBox                   = this.closeChatBox.bind(this);
        this.loadChatMessage                = this.loadChatMessage.bind(this);

    };

    asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
    }

    /* ============= Chat Box List Component ============= */

    openChatBox(userData, msgData = null, nextUrl, type = 1){
        this.removeUserObjectProps(userData);
        if(this._isMounted) {
            this.setState({
                chatElement : this.generateChatBox(userData, msgData, nextUrl, type)
            })
        }   
        
    }

    closeChatBox(userData){
        this.element.splice(
            this.element.findIndex(i => i.key === userData.Username), 1
        );
        this.element = this.regenerateListChatBox(this.element);
        if(this._isMounted) {
            this.setState({
                chatElement : this.element
            })
        }
    }

    loadChatMessage(action, userData, nextUrl = null){
        Presenter.ReadChatMessage(
            RequestProperties.ReadChatMessage(
                action, this,
                this.onReadChatSuccess,
                this.onReadChatFailed,
                userData, nextUrl
            )
        );
    };

    onReadChatSuccess(params, response) {
        if (params.action === 'read'){
            this.openChatBox(
                params.data.UserData,
                response.data.results.reverse(),
                response.data.next
            );
        }else if(params.action === 'next'){
            setTimeout(
                this.openChatBox(
                    params.data.UserData,
                    response.data.results.reverse(),
                    response.data.next, 0
                ),
            2000);
        }
    };

    onReadChatFailed(error) {
        console.log(error);
    };

    generateChatBox(userData, msgData = null, nextUrl, type){
        const notExist = (this.element.findIndex(i => i.key === userData.Username) === -1);
        if(notExist && (this.chatBoxRight + this.chatBoxWidth) <= this.chatBoxMaxWidth){
            this.element.push(
                this.renderChatBox(userData.Username, userData, msgData, nextUrl)
            );
            this.chatBoxRight += this.chatBoxWidth;
        }else if(!notExist){
            this.chatBoxRight = this.chatBoxRight;
            if(msgData !== null){
                if(type === 1){
                    this.addMessage(msgData);
                }else{
                    this.addPaginationMessage(msgData,userData.Username, nextUrl);
                }
            }
        }else{
            this.element.pop();
            this.element.unshift(
                this.renderChatBox(userData.Username, userData, msgData, nextUrl)
            );
            if(msgData !== null){
                this.element = this.regenerateListChatBox(this.element);
                this.addMessage(msgData);
            }else{
                console.log('null')
                this.element = this.regenerateListChatBox(this.element);
            }
        }
        return this.element;
    };

    regenerateListChatBox(element){
        this.chatBoxRight = 0;
        const el = element.map(val => {
            try {
                return (
                    this.renderChatBox(
                        val.key,
                        val.props.children.props.UserData,
                        val.props.children.props.MessageData,
                        val.props.children.props.NextUrl,
                        val.props.children.props.ShouldScroll,
                        true
                    )
                );
            }catch(err){
                return null;
            }finally{
                this.chatBoxRight += this.chatBoxWidth;
            }
        });
        return el;
    };

    addMessage(message, username = null){
        let userData    = null;
        let idx         = null;
        let oldMessage  = null;
        let nextUrl     = null;
        let right       = 0;
        for (let i = 0; i < this.element.length; i++){
            let currentData = this.element[i].props.children.props;
            if (currentData.UserData.Username === (username === null ? message.Sender : username)){
                idx         = i;
                userData    = currentData.UserData;
                right       = currentData.Right;
                nextUrl     = currentData.NextUrl;
                oldMessage  = currentData.MessageData;
                oldMessage.push(message);
                break;
            }
        }
        try{
            this.element.splice(
                idx, 1,
                this.renderChatBox(
                    userData.Username,
                    userData,
                    oldMessage,
                    nextUrl, true,
                    false, right
                )
            )
            if(this._isMounted) {
                this.setState({
                    chatElement : this.element
                })
            }
        }catch(err){
            return
        }
    };

    addPaginationMessage(message, username, NextUrl){
        let userData    = null;
        let idx         = null;
        let oldMessage  = null;
        let nextUrl     = null;
        let right       = 0;
        for (let i = 0; i < this.element.length; i++){
            let currentData = this.element[i].props.children.props;
            if(currentData.UserData.Username === username){
                idx         = i;
                oldMessage  = currentData.MessageData;
                userData    = currentData.UserData;
                right       = currentData.Right;
                nextUrl     = NextUrl;
                oldMessage  = message.concat(oldMessage)
                break;
            }
        }

        try{
            this.element.splice(idx, 1,
                this.renderChatBox(
                    userData.Username,
                    userData,
                    oldMessage,
                    nextUrl, false,
                    false, right
                )
            )
            if(this._isMounted) {
                this.setState({
                    chatElement : this.element
                })
            }
        }catch(err){
            console.log(err)
            return
        }
    };

    renderChatBox(key, userData, msgData = null, nextUrl, scroll = true,  isRegenerate = false, right = this.chatBoxRight){
        return(
            <div key={key} >
                <ChatBox
                    UserData        = {userData}
                    MessageData     = {msgData}
                    Width           = {this.chatBoxWidth}
                    Right           = {right}
                    ShouldScroll    = {scroll}
                    IsBot           = {!userData.hasOwnProperty('Online')}
                    IsRegenerate    = {isRegenerate}
                    OnMessageSent   = {this.messageSentHandler}
                    OnClose         = {this.closeChatBox}
                    OnLoadChat      = {this.loadChatMessage}
                    NextUrl         = {nextUrl}

                    UserReducer     = {this.props.UserReducer}
                />
            </div>
        );
    };

    messageSentHandler(response, username){
        // add sent message to chatBox
        this.addMessage(response, username);
    };

    /* ============= END Chat Box List Component ========== */


    /* ============= User List Component ============= */
    notificationCounter(userList){
        let notifCount = 0
        userList.forEach(user => {
            if(user.hasOwnProperty('UnreadMessage')){
                notifCount += 1
            }
        })
        this.props.setNotificationCounter(notifCount);
    };

    removeUserObjectProps(userData){
        this.userChatElement.forEach(user => {
            if (user.Username === userData.Username){
                if(userData.hasOwnProperty('UnreadMessage')){
                    try{
                        delete user.UnreadMessage
                    }catch(err){
                        console.log(err)
                    }
                }
            }
        })
        this.notificationCounter(this.userChatElement)
    };

    handleUserClick(userData){
        this.loadChatMessage('read', userData);
    };

    handleSearch(e){
        if(this._isMounted) {
            this.setState({
                onLineUserElement   : this.generateUserList(this.userChatElement.filter((res) => res.Online && res.Username !== this.user && (res.FirstName +' '+ res.LastName).toLowerCase().includes(e.target.value)).sort(this.sortUserList)),
                offLineUserElement  : this.generateUserList(this.userChatElement.filter((res) => res.Online === false && res.Username !== this.user && (res.FirstName +' '+ res.LastName).toLowerCase().includes(e.target.value)).sort(this.sortUserList), 0)
            })
        }
    }

    sortUserList(a, b){
        if(a.hasOwnProperty('FirstName') && b.hasOwnProperty('FirstName')){
            const A = a.FirstName.toUpperCase();
            const B = b.FirstName.toUpperCase();
            if (A < B)
                return -1
            if (A > B)
                return 1
            return 0
        }
    };

    generateUserList(list, status = 1 /* 1 = online */){
        let color       = null;
        let textColor   = null;
        let element     = null;

        if (status === 1){
            color = this.color[status];
            textColor = '#121213';
        }else{
            color =  this.color[status];
            textColor = '#7a7a7d';
        }

        if (list.length > 0){
            element = list.map((val) => {
                return (
                    <UserChatList
                        key         = {val.Username}
                        ListData    = {val}
                        TextColor   = {textColor}
                        Color       = {color}
                        IsBot       = {!val.hasOwnProperty('Online')}
                        OnUserClick = {this.handleUserClick}
                    />
                );
            });
        }
        return element;
    };

    onLoadUserChat(){
        Presenter.ReadUserBot(
            RequestProperties.ReadUserBot("Read", this, this.onReadBotSuccess, this.onReadFailed)
        );
        Presenter.ReadUserList(
            RequestProperties.ReadUserList("Read", this, this.onReadUserSuccess, this.onReadFailed)
        );
    };

    onLoadUserChatSummary(){
        Presenter.ReadUserChatSummary(
            RequestProperties.ReadUserChatSummary(
                "Read", this,
                this.onReadUserChatSummarySuccess,
                this.onReadFailed
            )
        );
    };

    onReadFailed(response) {
        try{
            console.log(response.data.detail)
        }catch(err){
            console.log(response)
        }
    };

    onReadUserSuccess(params, response) {
        for (var i = 0; i < response.data.length; i++) {
            this.userChatElement.push(response.data[i])
        }
        this.onLoadUserChatSummary();
    };

    onReadBotSuccess(params, response){
        for (var i = 0; i < response.data.length; i++) {
            this.userChatElement.push(response.data[i].Bot)
        }
        if(this._isMounted) {
            this.setState({
                botUserElement : this.generateUserList(this.userChatElement.filter(res => !res.hasOwnProperty('Online')))
            })
        }
    }

    onReadUserChatSummarySuccess(params, response){
        let filter = null;
        this.userChatElement.forEach((user,index) => {
            filter = response.data.filter(data => data.Sender === user.Username)[0]
            if(filter !== undefined){
                user.UnreadMessage = filter.UnreadMessage
            }
        })
        this.notificationCounter(this.userChatElement)
        if(this._isMounted) {
            this.setState({
                onLineUserElement   : this.generateUserList(this.userChatElement.filter((res) => res.Online && res.Username !== this.user).sort(this.sortUserList)),
                offLineUserElement  : this.generateUserList(this.userChatElement.filter((res) => res.Online === false && res.Username !== this.user).sort(this.sortUserList), 0)
            })
        }
        
    };

    renderUserList(state, groupTitle){
        if (state !== null){
            return (
                <div>
                    <div className="callout m-0 py-2 text-muted text-center bg-faded text-uppercase">
                        <small><b>{groupTitle}</b></small>
                    </div>
                    {state}
                </div>
            );
        }else{
            return null
        }
    };

    /* ================ END User List Component ============= */

    /* ================ RECEIVE Message Component ============= */

    handleMessage(msg){
        /* This method listen incoming connection/data from socket */

        try{
            let newMsgObj = null;
            const data = JSON.parse(msg);
            const newMsg = Object.assign({}, data.data);
            if (data.type === 'user-socket'){
                /* Get Online User */
                this.userChatElement.forEach(val => {
                    if(val.Username === newMsg.Username){
                        val.Online = newMsg.Online
                        val.LastOnline = newMsg.LastOnline
                    } 
                });
                this.element = this.regenerateListChatBox(this.element);
                if(this._isMounted) {
                    this.setState({
                        chatElement         : this.element,
                        onLineUserElement   : this.generateUserList(this.userChatElement.filter((res) => res.Online && res.Username !== this.user).sort(this.sortUserList)),
                        offLineUserElement  : this.generateUserList(this.userChatElement.filter((res) => res.Online === false && res.Username !== this.user).sort(this.sortUserList), 0)
                    })
                }
            }else if(data.type === "settings") {
              return null
            }else if(data.type === 'message' || data.type === 'bot-notif'){
                /* Get Incoming Messages */
                const userData = this.userChatElement.filter(res => res.Username === newMsg.Sender && res.Username !== this.user)
                const notExist = (this.element.findIndex(i => i.key === newMsg.Sender) === -1)

                // Add Message to ChatBox
                if (userData.length > 0 && notExist){
                    Notify.play();
                    this.loadChatMessage('read', userData[0]);
                }else{
                    if (hasFocus === false){
                        Notify.play();
                    }
                    this.addMessage(newMsg);
                }

                // Desktop Notification
                if(hasFocus === false){
                    const notification = new Notification(
                        userData[0].FirstName + ' ' + userData[0].LastName,
                        {
                            body : Module.MessageEditor(newMsg, false).Content,
                            icon : Logo,
                            dir  : 'ltr',
                            tag  : 'sometag'
                        }
                    );
                    setTimeout(() => { notification.close() }, 5000);
                }

                // Reassign Counter
                if(newMsg.hasOwnProperty('Extra')){
                    newMsgObj = JSON.parse(newMsg.Extra)
                }
                if(data.activity.includes('confirmation')){
                    if(newMsg.Type.includes('qr-accept')){
                        this.props.loadDataReassign(newMsgObj, 'qr-accept');
                    }else if(
                            newMsg.Type.includes('accept') ||
                            newMsg.Type.includes('cancel') ||
                            newMsg.Type.includes('reject')
                        ){
                        if(newMsgObj.ToUser !== this.user){
                            this.props.decrementReassignCounter('out')
                        }else{
                            this.props.decrementReassignCounter('in')
                        }
                        this.props.loadDataReassign(newMsgObj, 'accept');
                    }else if(newMsg.Type.includes('register')){
                        if(newMsgObj.ToUser !== this.user){
                            this.props.incrementReassignCounter('out')
                        }else{
                            this.props.incrementReassignCounter('in')
                        }
                        this.props.loadDataReassign(newMsgObj, 'register');
                    }
                }else if(data.activity === 'asset'){
                    this.props.loadDataReassign(newMsgObj, 'asset');
                    // if  (
                    //         newMsg.Type.includes('move') ||
                    //         newMsg.Type.includes('extend')
                    //     )
                    // {
                    //     // this.props.loadDataReassign(newMsgObj, 'move');
                    // }
                }
            }
        }catch(err){
            console.log('Unknown Message');
            console.log(err);
        }
    };

    handleWSOpen(){
        console.log("Connected! Welcome To AssetVault!");
    };

    handleWSClose(){
        console.log("Disconnected! Bye!");
    };

    /* ================ END RECEIVE Message Component  ============= */

    handleVisibilityChange() {
        if (document[hidden]) {
            hasFocus = false;
        } else {
            hasFocus = true;
        }
    };

    onWindowSizeChanged(){
        this.chatBoxMaxWidth = window.innerWidth - this.chatBoxWidth
        let isChange = this.chatBoxMaxWidth < this.chatBoxRight && this.chatBoxRight > this.chatBoxWidth
        if(isChange){
            while(isChange){
                this.element.pop();
                this.chatBoxRight -= this.chatBoxWidth
            }
            this.element = this.regenerateListChatBox(this.element);
            if(this._isMounted) {
                this.setState({
                    chatElement : this.element
                })
            }
            
        }
    };

    componentDidMount(){
        this._isMounted = true
        this.onLoadUserChat();
        if(typeof Notification !== 'undefined'){
            if (Notification.permission !== 'granted'){
                Notification.requestPermission();
            }
        }
        window.addEventListener('resize', this.onWindowSizeChanged)
        if (typeof document.hidden !== 'undefined') {
            hidden              = "hidden";
            visibilityChange    = "visibilitychange";
        } else if (typeof document.msHidden !== 'undefined') {
            hidden              = "msHidden";
            visibilityChange    = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== 'undefined') {
            hidden              = "webkitHidden";
            visibilityChange    = "webkitvisibilitychange";
        } else {
            console.log('hidden not found!')
        }
        if (typeof document.addEventListener === 'undefined' || typeof document.hidden === 'undefined') {
            console.log("This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
        } else {
            document.addEventListener(visibilityChange, this.handleVisibilityChange, false);
        }
    };

    componentWillUnmount(){
        this._isMounted = false
        windowStop()
        window.removeEventListener('resize', this.onWindowSizeChanged);
        document.removeEventListener(visibilityChange, this.handleVisibilityChange, false);
    };

    render() {
        return (
            <div >
            <aside className="aside-menu">
                <Nav tabs /*style={{ display : 'unset' }} */>
                    <NavItem>
                        <NavLink className='active' onClick={(e) => this.asideToggle(e)}>
                          <i className="fa fa-arrow-right"></i>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink>
                            <Input
                                type="text"
                                style={{ padding : 1, border : '1px solid rgba(0, 0, 0, 0)' }}
                                placeholder="Search"
                                onChange={(e) => this.handleSearch(e)}
                            />
                        </NavLink>
                    </NavItem>

                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        {this.renderUserList(this.state.botUserElement,'Notification')}
                        {this.renderUserList(this.state.onLineUserElement,'Online')}
                        {this.renderUserList(this.state.offLineUserElement,'Offline')}
                        {/*<hr className="transparent mx-3 my-0"/>*/}
                    </TabPane>
                </TabContent>
            </aside>
                <div className="card-block card-check">
                    <div className="flex flex-row-reverse">
                        <div style={{
                            display: 'flex',
                            position: 'fixed',
                            bottom: 0,
                        }}>
                            {this.state.chatElement}
                        </div>
                    </div>
                </div>

                <Websocket
                    url={ServerProperties.ATM_CLOUD.WS + 'chat/' + this.props.UserReducer.token}
                    onMessage={this.handleMessage}
                    onOpen={this.handleWSOpen}
                    onClose={this.handleWSClose}
                    reconnect={true}
                    debug={false}
                    ref='socket'
                />

            </div>
        );
    }
}

// export default Sidebar;
const mapStateToProps = (state) => {
  return {
      UserReducer: state.UserReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
        RunRedux: (data) => {
            dispatch(data);
        },
    };
};

// export default AssetScreen;
export default connect(mapStateToProps, mapDispatchToProps)(Aside);



// WEBPACK FOOTER //
// ./src/App/views/components/Aside/Aside.js